import { render } from "./TitleTypeComponent.vue?vue&type=template&id=20b8e9aa&scoped=true"
import script from "./TitleTypeComponent.vue?vue&type=script&lang=js"
export * from "./TitleTypeComponent.vue?vue&type=script&lang=js"

import "./TitleTypeComponent.vue?vue&type=style&index=0&id=20b8e9aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b8e9aa"]])

export default __exports__